import React, { useContext } from 'react';

import { InfiniteTable } from '../../components';
import { UserContext } from '../../contexts';

import { RequestRow } from '../atoms';

const headers = [
  'Request ID', 'Request Type', 'Brand', 'Model', 'Reference Number', 'Status', 'Date',
];

export function MerchantRequests({ merchant }) {
  const { user } = useContext(UserContext);

  return (
    <div className="p-3 mb-4 mt-4 list-container">
      <InfiniteTable
        className="contacts mobile-alternative sub-list"
        fetchUrl={`/api/merchant/${user.id}/requests/both`}
        responsive={false}
        fetchParams={{
          filters: {
            admin: '',
            channel: '',
            owner: 'merchant',
            owner_id: merchant.id,
            search: '',
            showDeleted: false,
            status: '',
          },
        }}
        fetchLimit={25}
        emptyText="No requests found for this merchant."
        headers={headers}
        onSelectClick={() => {}}
        RowComponent={RequestRow}
      />
    </div>
  );
}
